import type { ProtocolEdgeType } from '@ipfabric/utils';

export const isProtocolStpi = (protocol?: ProtocolEdgeType): boolean =>
  protocol === 'stpi' || protocol === 'stpi-blocked';
